import { render, staticRenderFns } from "./ThoughtVerseControlsWidget.vue?vue&type=template&id=21a74c42&scoped=true"
import script from "./ThoughtVerseControlsWidget.vue?vue&type=script&lang=js"
export * from "./ThoughtVerseControlsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a74c42",
  null
  
)

export default component.exports